export default __webpack_public_path__ + "static/media/danger.48ea2092.svg";